export default __webpack_public_path__ + "static/media/agustin9.13c50d20.png";